import { IEnvironment } from './iEnvironment';

export const environment: IEnvironment = {
  production: true,
  staging: false,
  'auth0:Domain': 'auth.brafton.com',
  // this needs to change to actual atlas/project-management app.
  'atlas:Auth0:ClientId': 'edMbEzvCUwCrs3it5Y2WGBkrB8R06l1t',
  'atlas:Auth0:AppName': 'project-management-app',
  'atlas:Endpoint': 'https://atlas.dev.brafton.com',
  'atlas:Logging:LogentriesToken': 'b596383b-28d8-4235-8067-6d721ea8a8d5',

  'deliverables:Api:Auth0:ClientId': 'g5bmvqlPivcm5nyC6CcE3UPjjonLfFHQ',
  'deliverables:Api:Auth0:AppName': 'deliverables-api',
  'deliverables:Api:Endpoint': 'https://deliverables-api.dev.brafton.com',

  'core:Api:Auth0:ClientId': 'MlkQFHTGjEmp15vdxObLWFJZy3yDXoIG',
  'core:Api:Auth0:AppName': 'core-api',
  'core:Api:Endpoint': 'https://core-api-lambda.dev.brafton.com',

  'assets:Api:Endpoint': 'https://assets-api.dev.brafton.com',
  'assets:Api:Auth0:ClientId': 'nQzuQm5OkCSLGut8FmV6fTDn3z01TMJ0',
  'assets:Api:Auth0:AppName': 'assets-api',

  'text:Api:Endpoint': 'https://text-api.dev.brafton.com',
  'text:Api:Auth0:ClientId': 'ClE6LFN2esecDHOb4Xg3SzVhb4OXeO3B',
  'text:Api:Auth0:AppName': 'text-api',

  'platform:Api:Endpoint': 'https://platform-api.dev.brafton.com',
  'platform:Api:Auth0:ClientId': '8oTKaZBjuu2zEbUkrkgaQQLyxVjSjGsR',
  'platform:Api:Auth0:AppName': 'platform-api',
  'platform:Wss:Endpoint': 'wss://platform-websockets-api.dev.brafton.com',

  'atlas:Api:Endpoint': 'https://atlas-api.dev.brafton.com',
  //'atlas:Api:Endpoint': 'http://localhost:19505',
  'atlas:Api:Auth0:ClientId': 'QqxKUo0XlU5H3WObv8Q1Ik2e7Z8jRjQv',
  'atlas:Api:Auth0:AppName': 'atlas-api',
  'atlas:Wss:Endpoint': 'wss://atlas-websockets-api.dev.brafton.com',

  'pictures:Endpoint': 'https://pictures.internal.brafton.com',
};
